var React = require('react');
var PropTypes = React.PropTypes;
import ImageUploader from "../ImageUpload/ImageUploader";
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import ReactTooltip from 'react-tooltip';
import CustomEditor from "../CustomEditor/CustomEditor";

var MIN_SOLUTION_AS_HINT = 3;

var Solution = React.createClass({
  handleSolutionValueChange: function(solution, e) {
    solution.value = e.target.value;
    this.forceUpdate();
  },
  onUpdateSolutionContent: function(solution, event) {
    var HTMLContent = event.editor.getData();
    var rawContent = HTMLContent;
    solution.value = HTMLContent;
    this.forceUpdate();
  },
  onUploadingImage: function(solution) {
    solution.isImageUploading = true;
    this.forceUpdate();
  },
  uploadImageDone: function(solution, response) {
    solution.isImageUploading = false;
    solution.value = response.url;
    this.forceUpdate();
  },
  addSolution: function() {
    var solution = this.state.solution;
    if (this.state.asHint) {
      solution = this.addSolutionWhenAsHintIsOn(solution);
    } else {
      solution.push(this.newSolution());
    }
    this.setState({
      solution: solution
    });
  },
  addSolutionWhenAsHintIsOn: function(solution) {
    var notShownItem = solution.pop()
    solution.push(this.newSolution(true));
    solution.push(notShownItem)
    return solution;
  },
  toggleSolution: function(e) {
    var solution = this.state.solution;
    var isChecked = e.target.checked;
    if (!isChecked) solution.splice(0, solution.length);
    
    if (!this.state.isShown) solution.push(this.newSolution());
    this.setState({
      isShown: !this.state.isShown,
      solution: solution,
      asHint: this.state.asHint && isChecked
    });
  },
  newSolution: function(asHintValue) {
    return {
      type: 'TEXT',
      value: '',
      asHint: asHintValue || false
    }
  },
  toogleHint: function() {
    var solution = this.state.solution;
    var isShown = this.state.isShown;
    if (!this.state.asHint && isShown) {
      if (solution.length < MIN_SOLUTION_AS_HINT) {
        var diff = MIN_SOLUTION_AS_HINT - solution.length;
        for (var i = 0; i < diff; i++) solution.push(this.newSolution());
      }
      
    }
    
    for (var j = 0; j < solution.length; j++) {
      if (j === solution.length-1) solution[j].asHint = false;
      else solution[j].asHint = !solution[j].asHint;
    }
    this.setState({
      asHint: !this.state.asHint,
      solution: solution,
    });
  },
  toggleImage: function(solution) {
    if (solution.type === 'TEXT') solution.type = 'IMAGE';
    else solution.type = 'TEXT';
    solution.value = "";
    this.forceUpdate();
  },
  verifySolutionData: function(solution) {
    var isShown = false,
        asHint = false;
    var currentIsShown = this.state.isShown || false    
    if (!solution || solution.length <= 0) {
      isShown = false;
      asHint = false;
    } else {
      for (var i = 0; i < solution.length; i++) {
        var curSolution = solution[i];
        if (curSolution.value || currentIsShown) isShown = true;
        if (curSolution.asHint) {
          asHint = true;
          break;
        }
      }
    }
    return {
      isShown: isShown,
      asHint: asHint
    }
  },
  removeSolution: function(solution) {
    var stateSolution = this.state.solution
    var solutionIndex = stateSolution.indexOf(solution);
    stateSolution.splice(solutionIndex, 1);

    var countHint = 0
    if (this.state.asHint) {
      for (var i in stateSolution) {
        if (stateSolution[i].asHint === true) {
          countHint++
        }
      }      
    }

    var isShown = stateSolution.length > 0
    this.setState({
      solution: stateSolution,
      isShown: isShown
    });

    if (this.state.asHint && countHint === 0) {
      this.toogleHint()
    }
  },

  removeImage: function(solution, e) {
    e.stopPropagation();
    solution.value = '';
    this.forceUpdate();
  },

  getInitialState: function() {
    return {
      isShown: false,
      solution: this.props.solution,
      asHint: false
    }
  },

  componentWillReceiveProps: function(nextProps) {
    var result = this.verifySolutionData(nextProps.solution);
    if (nextProps.solution && nextProps.solution.length > 0) {}
    else {
      if (!nextProps.solution) nextProps.solution = [];
      // nextProps.solution.push(this.newSolution());
    }
    this.setState({
      solution: nextProps.solution,
      asHint: result.asHint,
      isShown: result.isShown,
      type: nextProps.type || 21
    });
  },

  componentWillMount: function() {
    var result = this.verifySolutionData(this.state.solution);
    this.setState({
      asHint: result.asHint,
      isShown: result.isShown
    });
  },

  render: function() {
    var _this = this;
    console.log(this.state.solution)
    return (
      <div className="solution-container">
        <div className="dp-table" style={{"marginBottom": "10px"}}>
          <div className="dp-table-cell">
            <Toggle label="Solution" labelPosition="right" labelStyle={{fontSize: "16px"}} onToggle={_this.toggleSolution} defaultToggled={_this.state.isShown}/>
          </div>
          <div className="dp-table-cell">
            <Checkbox defaultChecked={_this.state.asHint} label="Treat as Hint" className="dp-table-cell" onCheck={_this.toogleHint}/>
          </div>
        </div>
        {
          _this.state.isShown &&
          <div>
            <div className="solution-items">
              {
                _this.state.solution.map(function(solution, index) {
                  return (
                    <div key={index} className="dp-table" style={{"marginBottom": "10px"}}>
                      <div className="dp-table-cell" style={{"width": "150px", "verticalAlign": "top", "paddingTop": "4px", "paddingLeft": "15px"}}>
                        <Toggle label="Image" onToggle={_this.toggleImage.bind(_this, solution)} labelPosition="right" style={{"display": "inline-block"}} defaultToggled={solution.type === 'IMAGE'}/>
                      </div>
                      <div className="dp-table-cell" style={{"position": "relative"}}>
                        {
                          _this.state.asHint &&
                          <span style={{"position": "absolute", "top": 0, "left": 0, "width": "70px", "lineHeight": "34px"}}>{_this.state.asHint && _this.state.solution.length === index+1 ? 'Not shown' : 'Hint ' + (index+1)}</span>
                        }
                        {
                          solution.type === 'TEXT' ?
                          <div style={{"paddingLeft": "70px"}}>
                          {
                            _this.state.type !== 11 ? 
                            <CustomEditor
                            content={solution.value}
                            events={{
                              "change": _this.onUpdateSolutionContent.bind(_this, solution)
                            }}
                            />
                            :
                            <input className="form-control" type="text" placeholder="Enter your solution here" value={solution.value} onChange={_this.handleSolutionValueChange.bind(_this, solution)}/>
                          }
                          </div>
                          :
                          <div style={{"width": "100%", "maxWidth": "500px", "paddingLeft": "70px"}}>
                            <ImageUploader onUploading={_this.onUploadingImage.bind(_this, solution)} onUploadDone={_this.uploadImageDone.bind(_this, solution)}>
                              { solution.type === 'IMAGE' && !solution.value &&
                                <div>
                                  <div className="img-intrinsic input intrinsic-2x1" style={{"background": "#ddd"}}>
                                    {solution.isImageUploading &&
                                      <div className="intrinsic-item">
                                        <CircularProgress className="loading"/>
                                      </div>}
                                  </div>
                                  <div className="img-text-placehoder">
                                      Click here to upload picture
                                  </div>
                                </div>
                              }
                              {
                                solution.type ==='IMAGE' && solution.value &&
                                <div>
                                  <div className="remove-image" data-tip data-for={"tt-remove-image-solution-" + index} onClick={_this.removeImage.bind(_this, solution)}>
                                    <i className="fa fa-remove"></i>
                                  </div>
                                  <img src={solution.value} style={{"width": "100%"}} alt="Solution"/>
                                  <ReactTooltip
                                    id={"tt-remove-image-solution-" + index}
                                    effect="solid"
                                    place="left">
                                    Remove image
                                  </ReactTooltip>
                                </div>
                              }
                            </ImageUploader>
                          </div>
                        }
                      </div>
                      
                      <div
                        className="dp-table-cell text-center"
                        style={{"width": "50px", "verticalAlign": solution.type === "IMAGE" ? "top" : "inherit"}}>
                        {
                          !(_this.state.asHint && _this.state.solution.length - 1 === index) &&
                          <div>
                            <i className="fa fa-remove" style={{"cursor": "pointer"}} data-tip data-for={"tt-solution-" + index} onClick={_this.removeSolution.bind(_this, solution)}></i>
                            <ReactTooltip
                              id={"tt-solution-" + index}
                              effect="solid"
                              place="left">
                              Remove solution
                            </ReactTooltip>
                          </div>
                        }
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <div className="actions">
              <RaisedButton
                onClick={this.addSolution}
                target="_blank"
                label="Add item"
                primary={true}
                icon={<i style={{"color": "white"}} className="fa fa-plus" />}
              />
            </div>
          </div>
        }
      </div>
    );
  },

  componentDidMount: function() {

  }

});

module.exports = Solution;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/Solution.js
 **/